import setFieldValue from "@iewcasia/Store/Handlers/CreateAccount/SetFieldValue";
import { CustomActions, CustomState } from "@iewcasia/Store/Reducers";
import {
    getRfqFormCheckboxBuilt,
    getRfqFormHintTextBuilt,
    getRfqFormLabelBuilt,
    OwnProps,
    requestQuoteStyles,
    setRequestFormEffects,
} from "@iewcasia/Widgets/CreateAccount/FormBaseComponent";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import TextField from "@insite/mobius/TextField";
import * as React from "react";
import { connect, DispatchProp, ResolveThunks } from "react-redux";

const mapStateToProps = (state: CustomState) => ({
    shippingPhone: state.customCreateAccountForm.fieldValues.shippingPhone,
    previouslyPurchased: state.customCreateAccountForm.fieldValues.previouslyPurchased,
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    DispatchProp<CustomActions>;

const shippingPhoneRegex = /^([\(\)/\-\.\+\s]*\d\s?(ext)?[\(\)/\-\.\+\s]*){10,}$/;

const shippingPhoneWidget: React.FC<Props> = ({ previouslyPurchased, shippingPhone, setFieldValue: widgetSetFieldValue }) => {
    const label = translate("Phone Number");
    const isRequired = false;
    const [fieldErrorMessage, setFieldErrorMessage] = React.useState("");

    const validateshippingPhoneNumber = () => {
        let errorMessage: any = "";
        if (!shippingPhone && isRequired) {
            errorMessage = siteMessage("ContactUsForm_PhoneNumberIsRequiredErrorMessage", label);
        } else if (shippingPhone && !shippingPhoneRegex.test(shippingPhone)) {
            errorMessage = siteMessage("ContactUsForm_PhoneNumberIsInvalidErrorMessage");
        }
        setFieldErrorMessage(errorMessage as string);
        return !errorMessage;
    };

    setRequestFormEffects(isRequired, shippingPhone, "shippingPhone", validateshippingPhoneNumber);

    const fieldChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        widgetSetFieldValue({ key: "shippingPhone", value: event.target.value });
    };

    const fieldBlurHandler = (event: React.FocusEvent<HTMLInputElement>) => {
        validateshippingPhoneNumber();
    };

    return (
        <TextField
            label={label}
            required={isRequired}
            value={shippingPhone || ""}
            error={fieldErrorMessage}
            onChange={fieldChangeHandler}
            onBlur={fieldBlurHandler}
        />
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(shippingPhoneWidget);
